<template>
	<section class="d-flex w-100">

		<div class="d-flex flex-column" id="exports">

			<div class="row header-emotivi mb-3 justify-content-around align-items-end">
				<div class="col">
					<h1>Extractions de données</h1>
				</div>
			</div>

			<div class="flex-grow-1 overflow-hidden d-flex">

				<div class="card card-no-margin">
					<div class="row">
						<div class="col-12 col-md-4">
							<h4>{{ exports_total }} résultats</h4>
						</div>
						<div class="col-12 col-md-8">
							<div class="d-flex justify-content-end">



								<m-form-combobox
									style="width: 200px"
									class="no-form-control-extract mr-2"
									v-if="$store.getters.checkUserAccess($router, '/establishments')"
									placeholder="Partenaire"
									v-model="filterPartner"
									:store-url="$config.server_url + '/extranet/2.0/establishments'"
									:store-params="{ ignorePopulate: true }"
									item-value="es_id"
									item-text="es_name"
								/>

								<div>
									<em-datepicker
										style="width: 120px"
										class="mr-2"
										v-model="filterStartDate"
										type="date"
										placeholder="Depuis"
										:show-time-panel="false"
										lang="fr-fr"
										format="DD/MM/YYYY"
									/>
								</div>

								<div>
									<em-datepicker
										style="width: 120px"
										class="mr-2"
										v-model="filterEndDate"
										type="date"
										placeholder="Jusqu'a"
										:show-time-panel="false"
										lang="fr-fr"
										format="DD/MM/YYYY"
									/>
								</div>

								<button class="btn btn-primary mr-2" @click="search()">
									Rech.
								</button>

								<button class="btn btn-primary" @click="download()">
									Exp.
								</button>

								<!--m-form-text
									class="ml-3 no-form-control"
									label="Rechercher"
									label-position="top"
									v-model="filterText"
									name="search"
									autocomplete
									@input="loadQuestions"
								/-->
							</div>
						</div>	
					</div>

					<m-list
						ref="exportslist"
						:dynamic="true"
						:items="exports"
						:item-height="30"
						:bgstrip="true"
					>
						<template v-slot:ths="{}">
							<th style="width: 50px">
								ID
							</th>
							<th style="width: 200px">
								Contact
							</th>
							<th style="width: 200px">
								Utilisateur
							</th>
							<th style="width: 100px">
								Abonnement
							</th>
							<th style="width: 120px">
								Créé le
							</th>
						</template>
						<template v-slot:tds="{ item }">
							<td style="width: 50px">
								#{{ item.en_id }}
							</td>	
							<td style="width: 200px">
								{{ item.co_invoice_firstname }} {{ item.co_invoice_name }}
							</td>
							<td style="width: 200px">
								{{ item.en_fullname }}
							</td>
							<td style="width: 100px">
								{{ item.en_state_subscription }}
							</td>
							<td class="text-center" style="width: 120px">
								{{ $moment(item.createdAt).format("DD/MM/YYYY HH[:]mm") }}
							</td>
						</template>
					</m-list>
				</div>

			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "faq",
	components: { },
	data() {
		return {
			exports: [],
			exports_total: 0,
			exports_limit: 50,
			exports_skip: 0,
			filterText: "",
			filterPartner: "",
			filterStartDate: "",
			filterEndDate: ""
		};
	},

	watch: {

	},

	async mounted() {

	},

	computed: {},

	methods: {

		getParams() {

			let params = {
				skip: this.exports_skip,
				limit: this.exports_limit
			};

			if(this.filterPartner){
				params.partner = this.filterPartner.es_id;
			}

			if(this.filterStartDate){
				params.startDate = this.filterStartDate.toJSON();
			}

			if(this.filterEndDate){
				params.endDate = this.filterEndDate.toJSON();
			}

			return params;
		},

		async download() {
	
			let query = "";

			Object.entries(this.getParams()).forEach(item => {
				query += query.length ? '&' : '?';
				query += `${item[0]}=${item[1]}`;
			})

			query += `&token=${this.$store.state.accesstoken}`;

			window.open(`${this.$config.server_url}/extranet/2.0/endusers/exports/xlsx${query}`)
		},

		async search() {

			let params = this.getParams();

			this.cancelAxiosSearch && this.cancelAxiosSearch();

			let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/endusers/exports/preview`, {
				params,
				cancelToken: new this.$axios.CancelToken(c => {
					this.cancelAxiosSearch = c;
				})
			});

			if(!response || !response.data){
				return;
			}

			this.exports = response.data.data;
			this.exports_total = response.data.total;
		},



		exportsChangeRange(skip) {
			this.exports_skip = skip;
			this.search();
		}
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";

.btn {
	height: 34px !important;
}
</style>